import { motion } from "framer-motion";
import Footer from "../../components/Footer/Footer";
import NewsLetter from "../../components/Newsletter/NewsLetter";
import AccountCreation from "../../components/AccountCreation/AccountCreation";
import HeroSection from "../../components/HeroSection2/HeroSection";
import EntranceAnimationWithLazyLoad from "../../components/EntranceAnimationWithLazyLoad";
import Hero from "../../components/HeroSection1/Hero";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "../../i18n/config";
import { useSelector } from "react-redux";
import { selectLocale } from "../../locales/localeSlice";

const LandingPage = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <div className="blinds-transition">
      {/* <I18nextProvider i18n={i18n}> */}
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "100%", opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Hero />
      </motion.div>
      <motion.div
        initial={{ y: "-50%", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 2.5, delay: 2 }}
      ></motion.div>
      <HeroSection />

      <EntranceAnimationWithLazyLoad>
        <AccountCreation />
      </EntranceAnimationWithLazyLoad>

      <EntranceAnimationWithLazyLoad>
        <NewsLetter
          newsLetterText={`${t("newsLetter.firstLine", { lng: currentLocale })}
                   ${t("newsLetter.secondLine", { lng: currentLocale })}
                   ${t("newsLetter.thirdLine", { lng: currentLocale })}`}
        />
      </EntranceAnimationWithLazyLoad>

      <EntranceAnimationWithLazyLoad>
        <Footer />
      </EntranceAnimationWithLazyLoad>
      {/* </I18nextProvider> */}
    </div>
  );
};

export default LandingPage;
